<template>
  <ContentWrap>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="活动类型" name="category" />
      <el-tab-pane label="活动标签" name="tag" />
    </el-tabs>
    <TagPanel v-if="activeTab === 'tag'" />
    <div v-show="activeTab === 'category'">
      <el-form :inline="true" :model="queryParams" class="-mb-15px">
        <el-form-item label="分类名称" prop="name">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入分类名称"
            clearable
            class="!w-200px"
            @keyup.enter="handleQuery"
          />
        </el-form-item>
        <el-form-item label="启用状态" prop="status">
          <el-select v-model="queryParams.status" placeholder="请选择" clearable class="!w-200px">
            <el-option label="启用" :value="0" />
            <el-option label="关闭" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery"><Icon icon="ep:search" /> 搜索</el-button>
          <el-button @click="resetQuery"><Icon icon="ep:refresh" /> 重置</el-button>
          <el-button
            type="primary"
            plain
            @click="openForm('create')"
            v-hasPermi="['activity:category:create']"
          >
            <Icon icon="ep:plus" /> 新增分类
          </el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="list" border>
        <el-table-column label="排序" prop="sort" width="80" />
        <el-table-column label="分类名称" prop="name" min-width="160" />
        <el-table-column label="关键词" prop="keywords" min-width="160" />
        <el-table-column label="图标" prop="cover" width="80">
          <template #default="scope">
            <el-image
              v-if="scope.row.cover"
              :src="scope.row.cover"
              style="width: 32px; height: 32px"
              :preview-src-list="[scope.row.cover]"
            />
          </template>
        </el-table-column>
        <el-table-column label="推荐" prop="isRec" width="80">
          <template #default="scope">
            <el-tag v-if="scope.row.isRec" type="success" effect="light">推荐</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="启用" prop="status" width="80">
          <template #default="scope">
            <el-tag :type="scope.row.status === 0 ? 'success' : 'info'" effect="light">
              {{ scope.row.status === 0 ? '启用' : '关闭' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="添加时间"
          prop="createTime"
          width="170"
          :formatter="dateFormatter"
        />
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template #default="scope">
            <el-button
              link
              type="primary"
              @click="openForm('update', scope.row.id)"
              v-hasPermi="['activity:category:update']"
            >
              编辑
            </el-button>
            <el-button
              link
              type="danger"
              @click="handleDelete(scope.row.id)"
              v-hasPermi="['activity:category:delete']"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        v-model:page="queryParams.pageNo"
        v-model:limit="queryParams.pageSize"
        :total="total"
        @pagination="getList"
      />
    </div>
  </ContentWrap>

  <!-- 分类表单弹窗 -->
  <Dialog v-model="dialogVisible" :title="dialogTitle" width="600px">
    <el-form ref="formRef" :model="formData" :rules="formRules" label-width="100px">
      <el-form-item label="父级分类" prop="parentId">
        <el-select v-model="formData.parentId" placeholder="顶级分类" clearable class="w-full">
          <el-option label="顶级分类" :value="0" />
          <el-option
            v-for="item in categoryOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="分类名称" prop="name">
        <el-input
          v-model="formData.name"
          placeholder="请输入分类名称"
          maxlength="30"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="分类图标" prop="cover">
        <el-input v-model="formData.cover" placeholder="请选择图标图片">
          <template #append>
            <el-button @click="openMediaSelector('cover')">🗂素材库</el-button>
          </template>
        </el-input>
        <el-image
          v-if="formData.cover"
          :src="formData.cover"
          style="width: 60px; height: 60px; margin-top: 8px"
          :preview-src-list="[formData.cover]"
          fit="cover"
        />
      </el-form-item>
      <el-form-item label="是否推荐" prop="isRec">
        <el-switch v-model="formData.isRec" :active-value="true" :inactive-value="false" />
      </el-form-item>
      <el-form-item label="启用状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio :value="0">启用</el-radio>
          <el-radio :value="1">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="formData.sort" :min="0" :value-on-clear="0" />
      </el-form-item>
      <el-form-item label="关键词" prop="keywords">
        <el-input v-model="formData.keywords" placeholder="请输入关键词" maxlength="50" />
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input
          v-model="formData.description"
          type="textarea"
          :rows="3"
          maxlength="255"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
    </template>
  </Dialog>

  <MediaSelector v-model="mediaVisible" :media-type="'IMAGE'" @confirm="onMediaConfirm" />
</template>

<script setup lang="ts">
import MediaSelector from '@/components/MediaSelector/index.vue'
import { dateFormatter } from '@/utils/formatTime'
import * as CategoryApi from '@/api/activity/category'
import TagPanel from './TagPanel.vue'

defineOptions({ name: 'ActivityCategory' })

const message = useMessage()
const activeTab = ref('category')
const loading = ref(true)
const list = ref<any[]>([])
const total = ref(0)
const categoryOptions = ref<any[]>([])
const queryParams = reactive({
  pageNo: 1,
  pageSize: 20,
  name: '',
  status: undefined as number | undefined
})

const getList = async () => {
  loading.value = true
  try {
    const data = await CategoryApi.getCategoryPage(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

// 加载分类下拉选项（父级选择器用）
const loadCategoryOptions = async () => {
  const data = await CategoryApi.getCategoryListAll()
  categoryOptions.value = data || []
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryParams.name = ''
  queryParams.status = undefined
  handleQuery()
}

onMounted(() => {
  getList()
  loadCategoryOptions()
})

// ===== 弹窗表单 =====
const dialogVisible = ref(false)
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref()
const formData = reactive<any>({
  id: undefined,
  parentId: 0,
  name: '',
  cover: '',
  isRec: false,
  status: 0,
  sort: 0,
  keywords: '',
  description: ''
})
const formRules = {
  name: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '启用状态不能为空', trigger: 'change' }]
}

const openForm = async (type: 'create' | 'update', id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = type === 'create' ? '新增分类' : '编辑分类'
  resetForm()
  if (id) {
    const data = await CategoryApi.getCategory(id)
    Object.assign(formData, data)
  }
}

const resetForm = () => {
  formData.id = undefined
  formData.parentId = 0
  formData.name = ''
  formData.cover = ''
  formData.isRec = false
  formData.status = 0
  formData.sort = 0
  formData.keywords = ''
  formData.description = ''
  formRef.value?.clearValidate()
}

const submitForm = async () => {
  await formRef.value?.validate()
  submitLoading.value = true
  try {
    if (formData.id) {
      await CategoryApi.updateCategory(formData)
      message.success('修改成功')
    } else {
      await CategoryApi.createCategory(formData)
      message.success('新增成功')
    }
    dialogVisible.value = false
    getList()
  } finally {
    submitLoading.value = false
  }
}

const handleDelete = async (id: number) => {
  await message.confirm('确定删除该分类？')
  await CategoryApi.deleteCategory(id)
  message.success('删除成功')
  getList()
}

// ===== 素材选择器 =====
const mediaVisible = ref(false)
const mediaField = ref('')

const openMediaSelector = (field: string) => {
  mediaField.value = field
  mediaVisible.value = true
}

const onMediaConfirm = (items: any[]) => {
  if (items.length > 0) {
    ;(formData as any)[mediaField.value] = items[0].url
  }
}
</script>
